import { useActivitiesContext } from '../context'

export function useSelectedFiltersCount() {
  const [{ filters }] = useActivitiesContext()

  let count: number = 0

  count += filters.closingActivities.filters.reduce(
    (acc, filter) => (filter.isSelected ? acc + 1 : acc),
    0,
  )

  count += filters.customActivities.filters.reduce(
    (acc, filter) => (filter.isSelected ? acc + 1 : acc),
    0,
  )

  count += filters.statusUpdates.filters.reduce(
    (acc, filter) => (filter.isSelected ? acc + 1 : acc),
    0,
  )

  return count
}
